import { TimelineItem, Button, AlertDialog } from '@yaradigitallabs/ahua-react';

type AlertDialogBoxProps = {
  open: boolean;
  onSetOpenAlertDialogBox: (open: boolean) => void;
  onAddLater?: () => void;
  onAddNow?: () => void;
  shouldAddFormula?: boolean;
};

export const AlertDialogBox = ({
  open,
  onAddLater,
  onAddNow,
  shouldAddFormula,
  onSetOpenAlertDialogBox,
}: AlertDialogBoxProps) => {
  return (
    <AlertDialog
      align="center"
      colorConcept="success"
      iconSrc="Check"
      type="icon"
      open={open}
      onOpenChange={open => {
        onSetOpenAlertDialogBox(open);
      }}
    >
      <AlertDialog.Content css={{ width: '300px', maxWidth: '300px' }}>
        <AlertDialog.Start>
          <AlertDialog.Media
            align="center"
            colorConcept={shouldAddFormula ? 'destructive' : 'brand'}
            iconSrc={shouldAddFormula ? 'Bang' : 'Info'}
            type="icon"
          />
        </AlertDialog.Start>
        <AlertDialog.Middle>
          <AlertDialog.Title align="center">
            {shouldAddFormula
              ? 'Formula is required'
              : 'No data will be collected'}
          </AlertDialog.Title>
          <AlertDialog.Description align="center">
            {shouldAddFormula
              ? 'As the scheduling interval is set, you need to add a formula'
              : "Without a formula, this soft tag won't collect data. You can add a formula now or edit the soft tag later."}
          </AlertDialog.Description>
        </AlertDialog.Middle>
        <AlertDialog.End>
          <TimelineItem.ButtonGroup
            buttonWidth="block"
            orientation="vertical"
            size="s"
          >
            {!shouldAddFormula && (
              <Button onClick={onAddLater} variant="primary">
                Proceed and add formula later
              </Button>
            )}
            <Button onClick={onAddNow} variant="ghost">
              Add formula now
            </Button>
          </TimelineItem.ButtonGroup>
        </AlertDialog.End>
      </AlertDialog.Content>
    </AlertDialog>
  );
};
